import { render, staticRenderFns } from "./ContainerAssistants.vue?vue&type=template&id=28decdff&"
import script from "./ContainerAssistants.vue?vue&type=script&lang=js&"
export * from "./ContainerAssistants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports